import { action } from 'satcheljs';

export const onAdCreativePageInitialized = action('onAdCreativePageInitialized', (publisherId?: number) => ({ publisherId }));
